/**
 * Flickity v3 is CJS-only (module.exports). Vite/Rollup needs a namespace import.
 */
import * as FlickityModule from "flickity";

const Flickity = FlickityModule.default ?? FlickityModule;

export default Flickity;
